export default __webpack_public_path__ + "static/media/305.ccc22a36.jpg";